module.exports = __webpack_public_path__ + "static/media/headerImg.80af5a47.png";